import { useTranslation } from 'react-i18next'
import React from 'react'

import { compactString } from '../../../utils/helpers/string'
import FilterLink from '../../../components/filter/FilterLink'
import MinicrudPickerModal from './MinicrudPickerModal'

const MinicrudPicker = ({ value, label, icon, ...props }) => {
  const { t } = useTranslation()
  const [open, setOpen] = React.useState(false)

  return (
    <>
      <FilterLink
        icon={icon || 'RiPriceTag3Line'}
        label={label || 'Tipos'}
        value={compactString(value, { t: t, tField: 'typeIds' })}
        onClick={() => setOpen(true)}
      />
      <MinicrudPickerModal open={open} onClose={setOpen} value={value} {...props} />
    </>
  )
}

export default MinicrudPicker
